var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogomob = function SvgLogomob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B4D8F",
    fillRule: "evenodd",
    d: "M.071.025H7.12L7.145 16H.111zM8.854 0h7.036l.039 15.975H8.882z",
    clipRule: "evenodd"
  })));
};
export { SvgLogomob as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4wNzEyODkxIDAuMDI1MzkwNkg3LjExOTI4TDcuMTQ1MzcgMTUuOTk5M0gwLjExMTExM0wwLjA3MTI4OTEgMC4wMjUzOTA2WiIgZmlsbD0iIzBCNEQ4RiIvPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljg1NDQ5IDBIMTUuODg5N0wxNS45Mjg2IDE1Ljk3NTNIOC44ODE1TDguODU0NDkgMFoiIGZpbGw9IiMwQjREOEYiLz4KPC9zdmc+Cg==";